module.exports = __webpack_public_path__ + "static/fonts/HelveticaNeueCyr-Roman.88b7a42.woff";